import React from 'react';
import sanitizeWhiteList from "../sanitize-html.whitelist";
import sanitizeHtml from 'sanitize-html';
import { Container } from '@adobe/aem-react-editable-components';
import { withStandardBaseCssClass } from '@adobe/aem-core-components-react-base';
import { clickEvent, linkType } from '../../utils/AdobeDataLayerService';
import _ from 'lodash'
import './FrequentQuestions.scss'


const ComponentName = "Preguntas Frecuentes"
const gJson = {
  "@context": "https://schema.org",
  "@type": "FAQPage"
}

export class FrequentQuestions extends Container {
  constructor(props) {
    super(props);
    this.panelRefs = props.items.map(() => React.createRef())
    this.state = {
      expandedItems: [],
      singleExpansion: false
    }
    this.handleAccordionNavClick = this.handleAccordionNavClick.bind(this);
  }

  componentDidMount(){
    if(!this.props.isInEditor){
        let url = window.location.href.split("#")
        let idExpComponent = url[1]?.split("-") ? url[1]?.split("-") : ""
        let idExp = idExpComponent[0]?.trim()
        let idExpChild = idExpComponent[1]?.trim()
        if(idExp === this.props.id){
            let keyChild = this.props.items.find(elem => elem.elements.id?.value === idExpChild)
            let indexChild = this.props.items.indexOf(keyChild)
            if(this.panelRefs && keyChild){
                this.handleAccordionNavClick(keyChild)
                setTimeout(() => {
                    this.panelRefs[indexChild].current.focus()
                    this.panelRefs[indexChild].current.scrollIntoView(true)
                    window.scrollBy(0,-80)
                }, 300)
            }
        }
    }
}

  handleAccordionNavClick = (itemKey) => {
    const expandedItems = this.state.expandedItems
    let expandedItem = [...expandedItems]
    if (expandedItems.includes(itemKey.title)) {
      expandedItem = expandedItems.filter(item => item != itemKey.title)
    } else {
      expandedItem.push(itemKey.title)
    }
    this.setState({
      expandedItems: expandedItem,
    });
  }

  isItemExpanded(key) {
    return this.state.expandedItems.includes(key.title);
  }

  isInEditor(isExpanded) {
    return this.props.isInEditor ? `in-editor${isExpanded ? '--expanded' : '--hidden'}` : ''
  }

  get accordionContainerProps() {
    const attrs = this.containerProps;
    attrs['className'] = attrs.className + ' ' + this.props.baseCssClass;
    attrs['data-cmp-is'] = 'accordion';
    attrs['data-panelcontainer'] = 'accordion';
    attrs['id'] = this.props.id
    return attrs;
  }

  displayItem(key, isExpanded) {
    const indexToShow = key.elements?.answer?.value;
      const cssClass = isExpanded ? `${this.props.baseCssClass}__panel ${this.props.baseCssClass}__panel--expanded` : `${this.props.baseCssClass}__panel ${this.props.baseCssClass}__panel--hidden`;
      let transitionClass = "";
      if (!this.props.isInEditor) {
          transitionClass = isExpanded ? "accordion__transition__expanded" : "accordion__transition__hidden"
      }
      return (
        <div className={`${cssClass} ${this.isInEditor(isExpanded)} rteEditor ${transitionClass}`}
          role="region"
          data-cmp-hook-accordion="panel"
          aria-hidden={isExpanded}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(indexToShow, sanitizeWhiteList),
          }}>
        </div>
      )
  }

  renderHeadingButton(key, buttonCssClass, isExpanded) {
    const fqstate =  isExpanded ? ' Cerrar' : ' Abrir';
    return (
      <button className={`${buttonCssClass} ${this.isInEditor(isExpanded)}`} onClick={() => { this.handleAccordionNavClick(key); this.tagClick(sanitizeHtml(key.elements?.question?.value, sanitizeWhiteList), fqstate)}} data-cmp-hook-accordion="button">
        <h3 className={`${this.props.baseCssClass}__title body-l`}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(key.elements?.question?.value, sanitizeWhiteList),
          }}>
        </h3>
        {
          isExpanded ? <div><i className={`${this.props.baseCssClass}__icon icon-menos icon-transition`} /></div> : <i className={`${this.props.baseCssClass}__icon icon-mas icon-transition`} />
        }
      </button>
    )
  }

  renderTitle(children) {
    return (
      <div className={`${this.props.baseCssClass}__header`}>
        {children}
      </div>
    )
  }
  
  tagClick = (text = "", fqstate) => {
    clickEvent(
      ['Frequent questions', text],
        linkType.customLink,
        text+ fqstate
    )
}


  generateStructuringData() {
    let faqs = [...this.props.items]
    let newFaqs = []
    faqs.map(fq => {
      let newf = {
        "@type": "Question"
      }
      newf['name'] = fq.elements?.question?.value
      newf['acceptedAnswer'] = {
        "@type": "Answer",
        "text": fq.elements?.answer?.value
      }

      newFaqs.push(newf)
    })
    gJson['mainEntity'] = newFaqs
    return (
      <script type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(gJson) }}
      >
      </script>
    )
  }

  get accordionContent() {
    let itemsOrder = [...this.props.items]
    itemsOrder.sort(function (a, b) {
      return a.elements?.order?.value - b.elements?.order?.value
    })
    let notElements = !this.props.items[0].elements.order && !this.props.items[0].elements.answer && !this.props.items[0].elements.question
    if (notElements) {
      if (this.props.isInEditor) {
        return <div className="cq-Overlay--placeholder">{ComponentName}</div>
      }
      return null
    }
    return (
      itemsOrder.map((key, index) => {
        const isExpanded = this.state.expandedItems.includes(key.title);
        const buttonCssClass = isExpanded ? `${this.props.baseCssClass}__button ${this.props.baseCssClass}__button--expanded` : `${this.props.baseCssClass}__button`;
        const bgCssClass = this.props.baseCssClass;

        return (
          <div key={`accordion-index ${index}`}
            style={{ backgroundColor: this.props?.frequentQuestions?.backgroundcolor }}
            className={`${this.props.baseCssClass}__item ${bgCssClass}`}
            data-cmp-index={index}
            data-cmp-expanded={isExpanded}
            ref={this.panelRefs[index]}
          >
            {
              this.renderTitle(this.renderHeadingButton(key, buttonCssClass, isExpanded))
            }
            {this.displayItem(key, isExpanded)}
          </div>
        )
      })
    );
  }

  render() {
    const isEmpty = this.props?.items?.length === 0;
    return (
      <section {...this.accordionContainerProps}>
        {isEmpty && this.props.isInEditor && (
          <div class="cq-Overlay--placeholder">{ComponentName}</div>
        )}
        {!isEmpty && this.accordionContent}
        {
          !this.props.isInEditor && (
            this.generateStructuringData()
          )
        }
        {this.placeholderComponent}
      </section>
    )
  }

}

export default withStandardBaseCssClass(FrequentQuestions, "cmp-accordion");